import { inkBackgroundTokens, inkBorderTokens } from '@ds/tokens'

const tokens = {
  backgroundColor: inkBackgroundTokens.bgColorDefault,
  borderColor: inkBorderTokens.borderColorSubtle,
  borderRadius: inkBorderTokens.borderRadiusAlternate,
} as const

export default tokens
